import { useHead } from "unhead";

export const langMap = {
  english: "english",
  français: "french",
  português: "portuguese",
  // español: "spanish",
  // 日本語: "japanese",
  // deutsch: "german",
  // indonesian: "indonesia",
  // 简体中文: "chinese",
};

export const routeMap = {
  en: "english",
  fr: "french",
  es: "spanish",
  pt: "portuguese",
  ja: "japanese",
  de: "german",
  id: "indonesia",
  zh: "chinese",
};

// Get keys on the basis of value
export function getKeyByValue(obj, value) {
  return Object.entries(obj).find(([_, val]) => val === value)?.[0];
}

export function stripLanguagePrefix(path) {
  if (path.startsWith("/3d")) return path;
  // Regex to remove the language prefix (e.g., /en/ or /fr/)
  return path.replace(/^\/\w{2}(\/|$)/, "/");
}

export function setLocaleFlag(locale) {
  useHead({
    htmlAttrs: {
      lang: locale,
    },
  });
}
